import { FC, ReactNode } from 'react';
import Picker, { PickerProps } from 'components/Picker';
import classlist from 'utils/classlist';
import { isEmptyValue } from 'utils/helper';
import MobileContent from './MobileContent';
import PanelContent from './PanelContent';
import styles from './style.scss';

export interface OptionItem {
    value: string | number;
    label: ReactNode;
}

export interface FormSelectProps extends Pick<PickerProps, 'inputClassName'> {
    placeholder?: string;
    disabled?: boolean;
    className?: string;
    // 强制通过options来传递选项，组件内部会区分移动端或PC端来展示选项
    options: OptionItem[];
    // 移动端弹窗顶部标题
    mobileTitle?: ReactNode;
    value?: string | number;
    isInvalid?: boolean;
    onChange?: (value: string | number) => void;
}

/**
 * @component FormSelect 下拉选择组件 https://www.figma.com/design/7lfUKmAiXbsm5y0oC82NQN/Web-H5%E8%A7%84%E8%8C%83?node-id=1276-2561
 * @description 在PC端采用下拉面板选择形式，在移动端采用底部滑入的弹窗选择形式
 * @description 不兼容更新：number类型的value不会再强制转为string类型（旧版原生select会把number类型的value转换为string）
 */
const FormSelect: FC<FormSelectProps> = ({
    className,
    disabled,
    placeholder = __('Please Select'),
    options,
    inputClassName,
    mobileTitle,
    value,
    isInvalid,
    onChange
}) => {
    return (
        <Picker
            className={classlist(styles.root, className)}
            inputClassName={classlist(styles.input, inputClassName)}
            disabled={disabled}
            options={options}
            placeholder={placeholder}
            mobileComponent={props => <MobileContent {...props} title={mobileTitle} />}
            panelComponent={props => <PanelContent {...props} />}
            value={isEmptyValue(value) ? [] : [value!]}
            onChange={onChange ? val => onChange(val[0]) : undefined}
            isInvalid={isInvalid}
            hideHeader
        />
    );
};

export default FormSelect;
export * from './helper';
